import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import { Locale } from './../../overrides/model/Locale.js';
import type { Constructor } from '@whispli/types';

export class __TranslationSetting extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  /**
   * @deprecated For backwards-compatibility only. Use modelId
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private model_id!: string;

  @Expose({groups: ['client']})
  public get modelId() {
    return this.model_id
  }

  public set modelId(value) {
    this.model_id = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use modelType
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private model_type!: string;

  @Expose({groups: ['client']})
  public get modelType() {
    return this.model_type
  }

  public set modelType(value) {
    this.model_type = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use localeId
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private locale_id!: string;

  @Expose({groups: ['client']})
  public get localeId() {
    return this.locale_id
  }

  public set localeId(value) {
    this.locale_id = value
  }

  @Type(() => Locale)
  @Expose({ groups: ['client', 'server'] })
  public readonly locale!: Locale | null;
  /**
   * @deprecated For backwards-compatibility only. Use isEnabled
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_enabled!: boolean;

  @Expose({groups: ['client']})
  public get isEnabled() {
    return this.is_enabled
  }

  public set isEnabled(value) {
    this.is_enabled = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use isDefault
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  private is_default!: boolean;

  @Expose({groups: ['client']})
  public get isDefault() {
    return this.is_default
  }

  public set isDefault(value) {
    this.is_default = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private created_at!: string | null;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private updated_at!: string | null;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }
}
export type TranslationSetting = Omit<__TranslationSetting, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'model_id' | 'model_type' | 'locale_id' | 'is_enabled' | 'is_default' | 'created_at' | 'updated_at'>
export const TranslationSetting = __TranslationSetting as any as Constructor<TranslationSetting>
